import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { confirmationBase32EncodedCodeValidator, userEmailValidator, } from '#validation';
const initiateCodeLoginSchema = z.object({
    email: userEmailValidator,
});
export class InitiateCodeLoginDto extends createZodDto(initiateCodeLoginSchema) {
}
const codeLoginEmailVerificationSchema = z.object({
    email: userEmailValidator,
    verificationCode: confirmationBase32EncodedCodeValidator({
        requiredError: 'emailVerification.code.required',
        lengthError: 'emailVerification.code.length',
    }),
});
export class CodeLoginVerificationDto extends createZodDto(codeLoginEmailVerificationSchema) {
}
